import { render, staticRenderFns } from "./AccessControlPane.vue?vue&type=template&id=65767a80&scoped=true"
import script from "./AccessControlPane.vue?vue&type=script&lang=js"
export * from "./AccessControlPane.vue?vue&type=script&lang=js"
import style0 from "./AccessControlPane.vue?vue&type=style&index=0&id=65767a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65767a80",
  null
  
)

export default component.exports